export const PANEL_MIN_SIZE = 20
